import { getRegionFromRequest, isRestOfWorld } from './i18nHelpers';
/* eslint-disable id-length */
const taxInformationByCountry = {
    AE: {
        type: 'vat',
        taxID: '100450470800003',
    },
    AU: {
        type: 'gst',
        taxID: '48 130 545 003',
    },
    BH: {
        type: 'vat',
        taxID: '5073413',
    },
    CH: {
        type: 'vat',
        taxID: 'CHE-241.362.648 IVA',
    },
    GB: {
        type: 'vat',
        taxID: 'GB322664807',
    },
    IS: {
        type: 'vat',
        taxID: '144310',
    },
    JE: {
        type: 'vat',
        taxID: '0123213',
    },
    NL: {
        type: 'vat',
        taxID: 'NL8256.92.295.B01',
    },
    NO: {
        type: 'vat',
        taxID: '2058170',
    },
    NZ: {
        type: 'gst',
        taxID: '130452531',
    },
    SA: {
        type: 'vat',
        taxID: '311859102700003',
    },
    UK: {
        type: 'vat',
        taxID: 'GB322664807',
    },
};
/* eslint-enable id-length */
/**
 * Provides tax type and digital & physical tax IDs for countries where we have tax registration requirements
 * @param country The country we need tax information for
 * @returns TaxInformation: tax type (vat, gst, etc.), tax ID for digital purchases, and tax ID for physical purchases
 */
export const getTaxInformationForCountry = (country) => {
    const region = getRegionFromRequest(country);
    const taxInfo = taxInformationByCountry[country];
    if (taxInfo)
        return taxInfo;
    if (region === 'EU')
        return taxInformationByCountry.NL;
};
export const getTaxTypeForCurrency = (currency) => {
    const taxTypes = {
        aed: 'vat',
        aud: 'gst',
        cad: 'gst',
        eur: 'vat',
        gbp: 'vat',
        nzd: 'gst',
        sar: 'vat',
        usd: 'tax',
        inr: 'gst',
        qar: 'gst',
    };
    return taxTypes[currency];
};
/**
 * Returns whether to show messaging that additional taxes may be applied
 * @param country
 * @param currency
 */
export const canApplyAdditionalTaxes = (country, currency) => {
    const region = getRegionFromRequest(country);
    return ((region &&
        currency &&
        isRestOfWorld(currency, region) &&
        region !== 'HK' &&
        region !== 'IN') ||
        country === 'AX' ||
        country === 'FO');
};
/**
 * Returns whether country should show "Your price has been updated to reflect the VAT of your region"
 * @param country
 */
export const canPriceUpdateToIncludeVat = (country) => {
    return ['GG', 'JE'].includes(country);
};
/**
 * @deprecated – Do not use in new development! This determination should now come from the backend
 */
export const isDisplayedVatInclusive = (currency) => {
    return ['aed', 'aud', 'eur', 'gbp', 'inr', 'nzd', 'sar'].includes(currency);
};
